// extracted by mini-css-extract-plugin
export default {"StyledUploadContainerSingle":"UploadDoc_StyledUploadContainerSingle__cKlM4","StyledContentContainerSingle":"UploadDoc_StyledContentContainerSingle__D5-0T"};